import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IonItem } from '@ionic/angular/standalone';

import { IconNames } from '../../shared';
import { SvgIconComponent } from '../icons/svg-icon/svg-icon.component';

@Component({
    selector: 'lib-item',
    standalone: true,
    imports: [CommonModule, IonItem, SvgIconComponent],
    templateUrl: './item.component.html',
    styleUrl: './item.component.css'
})
export class ItemComponent {
    /* eslint-disable */
    @Input('iconName') iconName: IconNames | undefined;
    @Input('detail') detail: boolean = false;
    @Input('routerLink') routerLink: string | undefined;
    @Input() button: boolean = false;
    @Input() borderTop: boolean = false;
    @Input() lines: 'full' | 'none' = 'full';
    @Input() iconColor: string | undefined = undefined;
    @Input() disabled: boolean = false;
    @Input() readonly: boolean = false;

    @Output() onClick = new EventEmitter();

    onItemClick() {
        if (this.disabled || this.readonly) return;
        this.onClick.emit();
    }
}
